// Copyright (c) 2017 Deere & Company

import Products from '../state/products';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const resetProducts = state =>
    Products.update(state, {
        $set: getDefaultState().products
    });

const updateProducts = (state, action) =>
    Products.update(state, {
        $set: action.products
    });

export default (state = getDefaultState().products, action) => {

    const actionTypes = {
        [actions.RESET_PRODUCTS_BY_CUSTOMER_SEARCH_RESULTS]: resetProducts,
        [actions.UPDATE_PRODUCTS_BY_CUSTOMER_SEARCH_RESULTS]: updateProducts
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/products-by-customer/reducers/products.js